export default __webpack_public_path__ + "static/media/ModalImage10.31c754da.PNG";